import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PointsChart = ({ stats, loading }) => {
  // If loading or no data, show placeholder
  if (loading || stats.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center bg-gray-50 rounded-lg">
        {loading ? (
          <div className="text-gray-500">Loading chart data...</div>
        ) : (
          <div className="text-gray-500">No data available for the selected route and date range.</div>
        )}
      </div>
    );
  }

// Format the data for the chart (and add 1 day to the date since Locale seems to be off by 1 day (a day early)
const chartData = stats.map(item => {
  const date = new Date(item.depart_date);
  date.setDate(date.getDate() + 1); // Add 1 day

  return {
    date: date.toLocaleDateString(),
    min: item.min_points,
    avg: Math.round(item.avg_points),
    max: item.max_points,
  };
});

  // Custom tooltip content
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 shadow-md rounded-md">
          <p className="font-semibold">{label}</p>
          <p className="text-sm text-green-600">
            Lowest: {payload[0].value.toLocaleString()} points
          </p>
          <p className="text-sm text-blue-600">
            Average: {payload[1].value.toLocaleString()} points
          </p>
          <p className="text-sm text-orange-600">
            Highest: {payload[2].value.toLocaleString()} points
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 12 }} 
            interval="preserveStartEnd" 
          />
          <YAxis 
            tick={{ fontSize: 12 }} 
            width={80}
            tickFormatter={(value) => value.toLocaleString()}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="min" 
            stroke="#10b981" 
            name="Lowest Points" 
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
          <Line 
            type="monotone" 
            dataKey="avg" 
            stroke="#2563eb" 
            name="Average Points" 
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
          <Line 
            type="monotone" 
            dataKey="max" 
            stroke="#f97316" 
            name="Highest Points" 
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PointsChart;